import { MapPin, ShieldCheck, Megaphone, HeartHandshake, Repeat, Ear } from "lucide-react";
import { Reveal } from "./Reveal";

const NEW_CUSTOMERS = {
  badge: "Nuovi clienti",
  title: "Valorizza chi ancora non ti conosce",
  accent: "#4285F4",
  items: [
    {
      icon: MapPin,
      title: "Sali su Google Maps",
      text: "Più recensioni e valutazioni alte spingono la tua attività in cima ai risultati locali: chi cerca nella tua zona trova prima te.",
    },
    {
      icon: ShieldCheck,
      title: "Fiducia a prima vista",
      text: "9 consumatori su 10 leggono le recensioni prima di scegliere. Una scheda piena di 5 stelle trasforma un curioso in un cliente.",
    },
    {
      icon: Megaphone,
      title: "Pubblicità gratuita e sincera",
      text: "Ogni recensione è un passaparola digitale che lavora per te 24 ore su 24, più credibile di qualsiasi campagna a pagamento.",
    },
  ],
};

const LOYALTY = {
  badge: "Fidelizzazione",
  title: "Rendi speciali i clienti che hai già",
  accent: "#34A853",
  items: [
    {
      icon: Ear,
      title: "Il cliente si sente ascoltato",
      text: "Chiedere un'opinione è un gesto di cura: chi viene ascoltato si sente importante e parla bene di te, online e offline.",
    },
    {
      icon: Repeat,
      title: "Chi recensisce, ritorna",
      text: "Lasciare una recensione crea un legame con il tuo brand: il cliente si sente parte della tua storia e torna più volentieri.",
    },
    {
      icon: HeartHandshake,
      title: "Feedback che ti fanno crescere",
      text: "Scopri subito cosa amano e cosa migliorare: ogni recensione è un consiglio gratuito per rendere il tuo servizio imbattibile.",
    },
  ],
};

const Column = ({ data, delay }) => (
  <Reveal delay={delay}>
    <div className="h-full rounded-[2rem] border border-slate-200 bg-white p-8 shadow-sm transition-shadow duration-300 hover:shadow-xl sm:p-10">
      <span
        className="rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-widest"
        style={{ backgroundColor: `${data.accent}14`, color: data.accent }}
      >
        {data.badge}
      </span>
      <h3 className="font-display mt-4 text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">
        {data.title}
      </h3>
      <div className="mt-8 flex flex-col gap-7">
        {data.items.map((item) => (
          <div key={item.title} className="group flex gap-4">
            <span
              className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6"
              style={{ backgroundColor: `${data.accent}14`, color: data.accent }}
            >
              <item.icon className="h-5 w-5" />
            </span>
            <div>
              <h4 className="font-display text-base font-bold text-slate-900 sm:text-lg">{item.title}</h4>
              <p className="mt-1 text-sm leading-relaxed text-slate-600">{item.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </Reveal>
);

export const Benefits = () => (
  <section id="benefici" data-testid="benefits-section" className="bg-[#F8FAFC] py-24 sm:py-32">
    <div className="mx-auto max-w-6xl px-5">
      <Reveal className="mx-auto max-w-2xl text-center">
        <span className="rounded-full bg-blue-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-[#4285F4]">
          Perché conviene
        </span>
        <h2 className="font-display mt-5 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
          Le recensioni non sono stelle: sono fatturato.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
          TapGoogle.com lavora su due fronti: conquista chi non ti conosce ancora e rafforza il legame con chi ti sceglie già.
        </p>
      </Reveal>
      <div className="mt-14 grid gap-8 lg:grid-cols-2">
        <Column data={NEW_CUSTOMERS} delay={0.1} />
        <Column data={LOYALTY} delay={0.25} />
      </div>
    </div>
  </section>
);
